export default __webpack_public_path__ + "static/media/icon-benefits.92be8991.svg";